import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import {RouteComponentProps} from "react-router-dom";
import {withI18n} from "react-i18next";
import Alert from "./Alert";

interface IProps extends StateProps, RouteComponentProps<any> {
  t?: any,
  delay?: any
}

class AlertMessage extends React.Component<IProps, {}> {
  render() {
    return (
      <Wrapper>
        {this.props.messages.map((value: any, index: number) => (
          <Alert key={index} value={value} index={index} />
        ))}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  background-color: transparent;
  position: fixed;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 0;
  z-index: 9;
`;

interface StateProps {
  messages?: any
}

function mapStateToProps(state: any): StateProps {
  return {
    messages: state.alert.messages
  };
}

export default connect(mapStateToProps, null)(withI18n() (AlertMessage))
